<template>
  <EditBox :name="name" :styleList="styleList" :currentStyle.sync="localStyle" :tip="`最多添加${maxCount}个文本项（可拖动排序）`">
    <!-- 文字设置 -->
    <FontSetting v-model="font" />

    <vuedraggable v-if="data && data.length" v-model="data" tag="ul" draggable="li" class="item-list">
      <li v-for="(item, index) in data" :key="index">
        <TextCard :title="`排序${index + 1}`" :index="index" v-model="data[index]" @remove-item="removeItem" />
      </li>
    </vuedraggable>
    <EmptyCard v-else />

    <ButtonGroup>
      <el-button type="primary" :disabled="data.length >= maxCount" icon="el-icon-plus" @click="addTextCard">添加文本</el-button>
    </ButtonGroup>
  </EditBox>
</template>

<script>
import vuedraggable from 'vuedraggable'
import TextCard from "./card/TextCard"
import EditBox from "./box/EditBox"
import FontSetting from "./setting/FontSetting"
import EmptyCard from "./card/EmptyCard"
import ButtonGroup from "./btngroup/ButtonGroup"
import editMixin from './mixins/editMixin'

export default {
  name: 'TextEdit',
  mixins: [editMixin],
  components: {
    vuedraggable,
    TextCard,
    EditBox,
    FontSetting,
    EmptyCard,
    ButtonGroup
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    styleList: {
      type: Array,
      default: () => []
    },
    currentStyle: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      maxCount: 8
    }
  },
  methods: {
    removeItem(index) {
      const newData = [...this.data]
      newData.splice(index, 1)
      this.updateValue({ data: newData })
    },
    addTextCard() {
      const newData = [...this.data]
      newData.push({ text: '' })
      this.updateValue({ data: newData })
    }
  },
  computed: {
    font: {
      get() {
        return this.value.font || {}
      },
      set(val) {
        this.updateValue({ font: val })
      }
    },
    data: {
      get() {
        return this.value.data || []
      },
      set(val) {
        this.updateValue({ data: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
